import React, { useState } from "react";
import PropTypes from "prop-types";

import CommentItem from "./CommentItem";

const CommentsOverview = ({ comments, open = false, error = false }) => {
  const [visibleIndex, setVisibleIndex] = useState(2);

  if (!open) {
    return null;
  }

  if (error) {
    return (
      <div className="message message--error">
        Er ging iets mis bij het ophalen van de comments.
      </div>
    );
  }

  return (
    <div className="ket-comments__comments">
      {comments.map((comment, index) => {
        if (index < visibleIndex) {
          return <CommentItem key={comment.id} {...comment} />;
        }

        return null;
      })}
      {visibleIndex < comments.length && (
        <button
          className="ket-comments__show-more"
          type="button"
          onClick={() => setVisibleIndex(comments.length)}
        >
          <span className="btn__text">Bekijk meer reacties</span>
          <svg className="btn__icon is-suffix" width="14" height="9">
            <use xlinkHref="#chevron-down" width="14" height="9" />
          </svg>
        </button>
      )}
    </div>
  );
};

CommentsOverview.propTypes = {
  open: PropTypes.bool.isRequired,
  comments: PropTypes.array.isRequired,
  error: PropTypes.bool,
};

CommentsOverview.defaultProps = {
  error: false,
};

export default CommentsOverview;
